<template>
  <div>
    <vx-card :title="$t('sections.accounting.dataSection.paymentDetail')" refresh-content-action @refresh="handleRefreshClick">
      <template v-if="visible">
        <div class="flex">
          <div class="flex-1 px-2">
            <label class="text-sm opacity-75">{{ $t("sections.accounting.dataForm.transactionDisplays") }}</label>
            <v-select v-model="form.transactionDisplay" :clearable="true" :options="transactionDisplaysOptions" name="transactionDisplay" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <div class="w-1/6 px-2 pt-5">
            <vs-button class="mr-1 w-full" color='success' @click="download()">{{ $t("general.download") }}</vs-button>
          </div>
        </div>

        <vs-table :data="transactionFilters">
          <template slot="thead">
            <vs-th>
              ประเภท
            </vs-th>
            <vs-th>
              วันที่
            </vs-th>
            <vs-th>
              งวด
            </vs-th>
            <vs-th>
              เดือน
            </vs-th>
            <vs-th>
              ค่าธรรมเนียมยกมา
            </vs-th>
            <vs-th>
              เบี้ยปรับยกมา
            </vs-th>
            <vs-th>
              ดอกเบี้ยยกมา
            </vs-th>
            <vs-th>
              เงินต้นยกมา
            </vs-th>
            <vs-th>
              ยอดเรียกเก็บคงเหลือยกมา
            </vs-th>
            <vs-th>
              ยอดดอกเบี้ยรับล่วงหน้ายกมา
            </vs-th>
            <vs-th>
              ยอดเรียกเก็บ
            </vs-th>
            <vs-th>
              ยอดเงินกู้
            </vs-th>
            <vs-th>
              ค่าธรรมเนียม
            </vs-th>
            <vs-th>
              เบี้ยปรับ
            </vs-th>
            <vs-th>
              ดอกเบี้ย
            </vs-th>
            <vs-th>
              ยอดชำระ
            </vs-th>
            <vs-th>
              ค่าธรรมเนียมคงเหลือ
            </vs-th>
            <vs-th>
              เบี้ยปรับคงเหลือ
            </vs-th>
            <vs-th>
              ดอกเบี้ยคงเหลือ
            </vs-th>
            <vs-th>
              เงินต้นคงเหลือ
            </vs-th>
            <vs-th>
              ยอดเรียกเก็บคงเหลือ
            </vs-th>
            <vs-th>
              ดอกเบี้ยรับล่วงหน้า
            </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="res" :key="index" v-for="(res, index) in data" :state="isState(res)">
              <vs-td>
                <p :class="isColorTransactionType(res)">{{ transactionType(res) }}</p>
              </vs-td>
              <vs-td>
                {{ transactionDate(res) }}
                <a @click="handleReceiveDatePopup(res)" v-if="res.transactionType === 'AddPayment'" ><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a>
              </vs-td>
              <vs-td>
                {{ paymentRoundSeq(res) }}
              </vs-td>
              <vs-td>
                {{ paymentRoundMonth(res) }}
              </vs-td>
              <vs-td>
                {{ _accruedFee(res) }}
              </vs-td>
              <vs-td>
                {{ _accruedPenalty(res) }}
              </vs-td>
              <vs-td>
                {{_accruedInterest(res) }}
              </vs-td>
              <vs-td>
                {{ _principle(res) }}
              </vs-td>
              <vs-td>
                {{ _outstandingBalance(res) }}
              </vs-td>
              <vs-td>
                {{ _balance(res) }}
              </vs-td>
              <vs-td>
                {{ paymentRoundAmount(res) | numberFormat }}
              </vs-td>
              <vs-td>
                {{ loanAmount(res) | numberFormat }}
              </vs-td>
              <vs-td>
                {{ feeDetail(res) | numberFormat }}
              </vs-td>
              <vs-td>
                {{ penaltyRate(res) }} ({{ penalty(res) | numberFormat }})
              </vs-td>
              <vs-td>
                {{ interestRate(res) }} ({{ interest(res) | numberFormat }})
              </vs-td>
              <vs-td>
                {{ paymentAmount(res) | numberFormat }}
                <a @click="handlePaidAmountPopup(res)" v-if="paidAmount(res) > 0" ><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a>
              </vs-td>
              <vs-td>
                {{ _accruedFeeRemain(res) }}
              </vs-td>
              <vs-td>
                {{ _accruedPenaltyRemain(res) }}
              </vs-td>
              <vs-td>
                {{ _accruedInterestRemain(res) }}
              </vs-td>
              <vs-td>
                {{ _principleRemain(res) }}
              </vs-td>
              <vs-td>
                {{ _outstandingBalanceRemain(res) }}
              </vs-td>
              <vs-td>
                {{ _balanceRemain(res)}}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </template>
    </vx-card>
    <vs-popup title="รายละเอียดวันที่รับชำระ" :active.sync="receiveDatePopup.active">
      <div v-html="receiveDatePopup.content"> </div>
    </vs-popup>
    <vs-popup title="รายละเอียดยอดชำระ" :active.sync="paidAmountPopup.active">
      <div v-html="paidAmountPopup.content"> </div>
    </vs-popup>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { round } from '@/utils'
  import moment from 'moment/moment'
  const _ = require('lodash');
  import {createNamespacedHelpers, mapGetters } from 'vuex'
  const { mapActions: mapAccountingActions, mapState: mapAccountingState} = createNamespacedHelpers('Accounting')

  export default {
    components: {
      vSelect
    },
    name: "ContractDetailHistoryList",
    props: ['reverse', 'type'],
    data(){
      return {
        form:{
          transactionDisplay: "AllAction"
        },
        receiveDatePopup:{
          active: false,
          content: ""
        },
        paidAmountPopup:{
          active: false,
          content: ""
        },
      }
    },
    computed: {
      ...mapAccountingState(['status', 'transactions', 'contract']),
      ...mapGetters({
        loanTypesOptions: "Master/loanTypesOptions",
        transactionDisplaysOptions: "Master/transactionDisplaysOptions",
        transactionTypesOptions: "Master/transactionTypesOptions",
      }),
      visible(){
        return !_.isEmpty(this.contract);
      },
      disableDeleteButton() {
        if ( this.transactions.length === 0 ) {
          return true
        }
        return false;
      },
      transactionFilters() {
        let transactions = Object.assign([], this.transactions);
        if(this.reverse){ transactions = transactions.reverse() }
        if(this.form.transactionDisplay === "All"){
          return transactions
        }else if(this.form.transactionDisplay === "LoanDetail"){
          return transactions.filter(res => {
            return res.transactionType === "AddLoanDetail"
          })
        }else if(this.form.transactionDisplay === "FeeDetail"){
          return transactions.filter(res => {
            return res.transactionType === "AddFeeDetail"
          })
        }else if(this.form.transactionDisplay === "Payment"){
          return transactions.filter(res => {
            return res.transactionType === "AddPayment"
          })
        }else if(this.form.transactionDisplay === "Monthly"){
          return transactions.filter(res => {
            return res.transactionType === "AddDaily" && moment(res.transactionDate).format("YYYY-MM-DD") ===  moment(res.transactionDate).startOf('month').format('YYYY-MM-DD')
          })
        }else if(this.form.transactionDisplay === "AllAction"){
          return transactions.filter(res => {
            return ( res.transactionType === "AddRestructuring")
            || ( res.transactionType === "AddLoanDetail")
            || (res.transactionType === "AddPayment")
            || (res.transactionType === "AddDaily" && moment(res.transactionDate).format("YYYY-MM-DD") ===  moment(res.transactionDate).startOf('month').format('YYYY-MM-DD'))
          })
        }else{
          return transactions
        }
      }
    },
    methods: {
      ...mapAccountingActions(['getTransactionsByContractIdRefresh', 'getTransactionEirsByContractIdRefresh']),
      async handleRefreshClick(card) {
        const vm = this
        const { getTransactionsByContractIdRefresh, getTransactionEirsByContractIdRefresh, type } = vm;
        if(type === "Normal"){
          await getTransactionsByContractIdRefresh({contractId: vm.contract.id})
        }else{
          await getTransactionEirsByContractIdRefresh({contractId: vm.contract.id})
        }
        card.removeRefreshAnimation(500)
      },
      async download(){
        const headerTitle = [
          "ประเภท",
          "วันที่",

          'ค่าธรรมเนียมยกมา (ปรับครงสร้างหนี้)',
          'เบี้ยปรับยกมา (ปรับครงสร้างหนี้)',
          'ดอกเบี้ยยกมา (ปรับครงสร้างหนี้)',
          'เงินต้นยกมา (ปรับครงสร้างหนี้)',
          'ยอดเรียกเก็บยังไม่ได้ชำระยกมา (ปรับครงสร้างหนี้)',

          "ค่าธรรมเนียมยกมา",
          "เบี้ยปรับยกมา",
          "ดอกเบี้ยยกมา",
          'เงินต้นยกมา',
          "ยอดเรียกเก็บยังไม่ได้ชำระยกมา",
          "ยอดดอกเบี้ยรับล่วงหน้ายกมา",
          "ยอดเรียกเก็บ",
          "ยอดเงินกู้",
          "ค่าธรรมเนียม",
          "อัตราเบี้ยปรับ",
          "เบี้ยปรับ",
          "อัตราดอกเบี้ย",
          "ดอกเบี้ย",
          "ยอดชำระทั้งหมด",
          "ยอดชำระค่าธรรมเนียม",
          "ยอดชำระเบี้ยปรับ",
          "ยอดชำระดอกเบี้บ",
          "ยอดชำระเงินต้น",

          'ค่าธรรมเนียมคงเหลือ (ปรับครงสร้างหนี้)',
          'เบี้ยปรับคงเหลือ (ปรับครงสร้างหนี้)',
          'ดอกเบี้ยคงเหลือ (ปรับครงสร้างหนี้)',
          'เงินต้นคงเหลือ (ปรับครงสร้างหนี้)',
          'ยอดเรียกเก็บยังไม่ได้ชำระคงเหลือ (ปรับครงสร้างหนี้)',

          "ค่าธรรมเนียมคงเหลือ",
          "เบี้ยปรับคงเหลือ",
          "ดอกเบี้ยคงเหลือ",
          "เงินต้นคงเหลือ",
          "ยอดเรียกเก็บยังไม่ได้ชำระคงเหลือ",
          "ดอกเบี้ยรับล่วงหน้า"
        ]

        const headerVal = [
          "transactionType",
          "transactionDate",

          'restructuringFee',
          'restructuringPenalty',
          'restructuringInterest',
          'restructuringPrinciple',
          'outstandingBalanceRestructuring',

          'accruedFee',
          'accruedPenalty',
          "accruedInterest",
          'principle',
          "outstandingBalance",
          "balance",
          "paymentRoundAmount",
          "loanAmount",
          "fee",
          'penaltyRate',
          "penalty",
          "interestRate",
          "interest",
          "paymentAmount",
          "paidAccruedFee",
          "paidAccruedPenalty",
          "paidAccruedInterest",
          "paidPrinciple",

          'restructuringFeeRemain',
          'restructuringPenaltyRemain',
          'restructuringInterestRemain',
          'restructuringPrincipleRemain',
          'outstandingBalanceRestructuringRemain',

          "accruedFeeRemain",
          "accruedPenaltyRemain",
          "accruedInterestRemain",
          "principleRemain",
          "outstandingBalanceRemain",
          "balanceRemain"
        ]
        const wscols = [
          {wch:25},{wch:10},{wch:20},{wch:20},{wch:20},
          {wch:20},{wch:20},{wch:20},{wch:20},{wch:20},
          {wch:20},{wch:20},{wch:20},{wch:20},{wch:20},
          {wch:20},{wch:20},{wch:20},{wch:20},{wch:20},
          {wch:20},{wch:20},{wch:20},{wch:20},{wch:20},
          {wch:20},{wch:20},{wch:20},{wch:20},{wch:20},
          {wch:20},{wch:20},{wch:20},{wch:20},{wch:20},
          {wch:20},{wch:20},{wch:20}
        ]
        import('@/vendor/Export2Excel').then(async excel => {
          const data = this.formatJson(headerVal, this.transactions)
          excel.export_json_to_excel({
            header: headerTitle,
            data: data.reverse(),
            filename: `ข้อมูลรายละเอียดธุรกรรม ${this.contract.contractName} ${moment().format("YYYYMMDDhhmmss")}`,
            autoWidth: false,
            bookType: "xlsx",
            wscols
          })
        })
      },
      formatJson (filterVal, jsonData) {
        const roundArr = [

          'restructuringFee',
          'restructuringPenalty',
          'restructuringInterest',
          'restructuringPrinciple',
          'outstandingBalanceRestructuring',

          'accruedFee',
          'accruedPenalty',
          "accruedInterest",
          'principle',
          "outstandingBalance",
          "balance",
          "paymentRoundAmount",
          "loanAmount",
          "fee",
          'penaltyRate',
          "penalty",
          "interestRate",
          "interest",
          "paymentAmount",
          "paidAccruedFee",
          "paidAccruedPenalty",
          "paidAccruedInterest",
          "paidPrinciple",

          'restructuringFeeRemain',
          'restructuringPenaltyRemain',
          'restructuringInterestRemain',
          'restructuringPrincipleRemain',
          'outstandingBalanceRestructuringRemain',

          "accruedFeeRemain",
          "accruedPenaltyRemain",
          "accruedInterestRemain",
          "principleRemain",
          "outstandingBalanceRemain",
          "balanceRemain"
        ]
        const dateArr = ['transactionDate']
        return jsonData.map((res, index) => filterVal.map(col => {
          console.log(index) // eslint-disable-line no-console
          if (col === 'transactionType') {
            let transactionType = "-"
            if(res.transactionType){
              transactionType = this.$t('getters.transactionTypesOptions')[res.transactionType]
            }

            const transactionTypes = ["AddLoanDetail", "AddFeeDetail", "AddPayment"];
            const details = ["loanDetail", "feeDetail", "payment"];

            transactionTypes.forEach((type, index) => {
              if(res.transactionType === type && res[details[index]] && res[details[index]].adjustment) {
                transactionType = this.$t('sections.accounting.dataForm.adjustment');
              }
            });
            return transactionType
          } else if (col === 'loanAmount') {
            let loanAmount = "0"
            if(res.loanDetail){
              loanAmount = res.loanDetail.amount
            }
            return loanAmount
          } else if (col === 'paymentAmount') {
            let paymentAmount = "0"
            if(res.payment){
              paymentAmount = round(res.payment.paymentAmount, 2);
            }
            return paymentAmount
          } else if (roundArr.includes(col)) {
            return round(res[col], 2);
          } else if (dateArr.includes(col)){
            const timestamp = Date.parse(res[col]);
            let date = "-"
            if (isNaN(timestamp) === false) date = new Date(timestamp);
            return date
          } else {
            return res[col]
          }
        }))
      },
      async handleReceiveDatePopup(res){
        const content = `
          <p>วันที่รับชำระ: ${res.payment.receiveDate}</p>
        `
        this.receiveDatePopup = {
          active: true,
          content: content
        }
      },
      async handlePaidAmountPopup(res){
        const { paidAccruedFee,  paidAccruedPenalty, paidAccruedInterest, paidPrinciple, balanceRemain } = res
        let content = "";
        content = `
          <p>ยอดชำระค่าธรรมเนียม: ${round(paidAccruedFee, 2)} บาท</p>
          <p>ยอดชำระเบี้ยปรับ: ${round(paidAccruedPenalty, 2)} บาท</p>
          <p>ยอดชำระดอกเบี้ย: ${round(paidAccruedInterest, 2)} บาท</p>
          <p>ยอดดอกเบี้ยรับล่วงหน้า: ${round(balanceRemain, 2)} บาท</p>
          </br>
          <p>ยอดชำระเงินต้น: ${round(paidPrinciple, 2)} บาท</p>
        `
        this.paidAmountPopup = {
          active: true,
          content: content
        }
      },
      transactionType(res){
        let transactionType = "-"
        if(res.transactionType){
          transactionType = this.$t('getters.transactionTypesOptions')[res.transactionType]
        }

        const transactionTypes = ["AddLoanDetail", "AddFeeDetail", "AddPayment"];
        const details = ["loanDetail", "feeDetail", "payment"];

        transactionTypes.forEach((type, index) => {
          if(res.transactionType === type && res[details[index]] && res[details[index]].adjustment) {
            transactionType = this.$t('sections.accounting.dataForm.adjustment');
          }
        });
        return transactionType
      },
      transactionDate(res){
        let transactionDate = "-"
        if(res){
          transactionDate = this.$options.filters.convYYYYMMDDToDDMMYYYY(res.transactionDate);
        }
        return transactionDate
      },
      paymentRoundSeq(res){
        let paymentRoundSeq = "-"
        if(res.paymentRound){
          paymentRoundSeq = res.paymentRound.paymentRoundSeq
        }
        return paymentRoundSeq
      },
      paymentRoundMonth(res){
        let paymentRoundMonth
        if(res.paymentRound){
          paymentRoundMonth = moment(res.paymentRound.paymentRoundDate).format('MMM')
        }
        return paymentRoundMonth
      },
      paymentRoundAmount(res){
        let paymentRoundAmount = 0
        if(res){
          paymentRoundAmount = res.paymentRoundAmount
        }
        return paymentRoundAmount
      },
      _accruedFee(res){
        const { numberFormat } = this.$options.filters;
        const { accruedFee, restructuringFee } = res
        return `${numberFormat(accruedFee)} ${restructuringFee > 0 ? `(${numberFormat(restructuringFee)})` : ''}`;
      },
      _accruedPenalty(res){
        const { numberFormat } = this.$options.filters;
        const { accruedPenalty, restructuringPenalty } = res
        return `${numberFormat(accruedPenalty)} ${restructuringPenalty > 0 ? `(${numberFormat(restructuringPenalty)})` : ''}`;
      },
      _accruedInterest(res){
        const { numberFormat } = this.$options.filters;
        const { accruedInterest, restructuringInterest } = res
        return `${numberFormat(accruedInterest)} ${restructuringInterest > 0 ? `(${numberFormat(restructuringInterest)})` : ''}`;
      },
      _principle(res){
        const { numberFormat } = this.$options.filters;
        const { principle, restructuringPrinciple } = res
        return `${numberFormat(principle)} ${restructuringPrinciple > 0 ? `(${numberFormat(restructuringPrinciple)})` : ''}`;
      },
      _outstandingBalance(res){
        const { numberFormat } = this.$options.filters;
        const { outstandingBalance, outstandingBalanceRestructuring } = res
        return `${numberFormat(outstandingBalance)} ${outstandingBalanceRestructuring > 0 ? `(${numberFormat(outstandingBalanceRestructuring)})` : ''}`;
      },
      _balance(res){
        const { numberFormat } = this.$options.filters;
        const { balance } = res
        return `${numberFormat(balance)}`;
      },
      feeDetail(res){
        let feeDetail = 0
        if(res.feeDetail){
          feeDetail = res.feeDetail.amount
        }
        return feeDetail
      },
      loanAmount(res){
        let loanAmount = 0
        if(res.loanDetail){
          loanAmount = res.loanDetail.amount
        }
        return loanAmount
      },
      paymentAmount(res){
        let paymentAmount = 0
        if(res.transactionType === 'AddDaily'){
          const { paidAccruedFee,  paidAccruedPenalty, paidAccruedInterest, paidPrinciple } = res
          paymentAmount = paidAccruedFee + paidAccruedPenalty + paidAccruedInterest + paidPrinciple
        }else if(res.transactionType === 'AddPayment'){
          if(res.payment){
            paymentAmount = res.payment.paymentAmount
          }
        }

        return paymentAmount
      },
      paidAmount(res){
        let paidAmount = 0
        if(res){
          const { paidAccruedFee,  paidAccruedPenalty, paidAccruedInterest, paidPrinciple } = res
          paidAmount = paidAccruedFee + paidAccruedPenalty + paidAccruedInterest + paidPrinciple
        }
        return paidAmount
      },
      penaltyRate(res){
        let penaltyRate = 0
        if(res){
          penaltyRate = `${res.penaltyRate}%`
        }
        return penaltyRate
      },
      penalty(res){
        let penalty = 0
        if(res){
          penalty = res.penalty
        }
        return penalty
      },
      interestRate(res){
        let interestRate = 0
        if(res){
          interestRate = `${res.interestRate}%`
        }
        return interestRate
      },
      interest(res){
        let interest = 0
        if(res){
          interest = res.interest
        }
        return interest
      },
      _accruedFeeRemain(res){
        const { numberFormat } = this.$options.filters;
        const { accruedFeeRemain, restructuringFeeRemain } = res
        return `${numberFormat(accruedFeeRemain)} ${restructuringFeeRemain > 0 ? `(${numberFormat(restructuringFeeRemain)})` : ''}`;
      },
      _accruedPenaltyRemain(res){
        const { numberFormat } = this.$options.filters;
        const { accruedPenaltyRemain, restructuringPenaltyRemain } = res
        return `${numberFormat(accruedPenaltyRemain)} ${restructuringPenaltyRemain > 0 ? `(${numberFormat(restructuringPenaltyRemain)})` : ''}`;
      },
      _accruedInterestRemain(res){
        const { numberFormat } = this.$options.filters;
        const { accruedInterestRemain, restructuringInterestRemain } = res
        return `${numberFormat(accruedInterestRemain)} ${restructuringInterestRemain > 0 ? `(${numberFormat(restructuringInterestRemain)})` : ''}`;
      },
      _principleRemain(res){
        const { numberFormat } = this.$options.filters;
        const { principleRemain, restructuringPrincipleRemain } = res
        return `${numberFormat(principleRemain)} ${restructuringPrincipleRemain > 0 ? `(${numberFormat(restructuringPrincipleRemain)})` : ''}`;
      },
      _outstandingBalanceRemain(res){
        const { numberFormat } = this.$options.filters;
        const { outstandingBalanceRemain, outstandingBalanceRestructuringRemain } = res
        return `${numberFormat(outstandingBalanceRemain)} ${outstandingBalanceRestructuringRemain > 0 ? `(${numberFormat(outstandingBalanceRestructuringRemain)})` : ''}`;
      },
      _balanceRemain(res){
        const { numberFormat } = this.$options.filters;
        const { balanceRemain } = res
        return `${numberFormat(balanceRemain)}`;
      },
      isState(res){
        let isState = null
        if(res.transactionType === "AddRestructuring"){
          isState = "success"
        } else if(res.transactionType === "AddLoanDetail"){
          isState = "success"
        } else if(res.transactionType === "AddFeeDetail"){
          isState = "success"
        }else if(res.transactionType === "AddPayment"){
          isState = "warning"
        }
        return isState
      },
      isColorTransactionType(res){
        let isTextColor = null
        if(res.transactionType === "AddRestructuring"){
          isTextColor = "text-success"
        }else if(res.transactionType === "AddLoanDetail"){
          isTextColor = "text-success"
        }else if(res.transactionType === "AddFeeDetail"){
          isTextColor = "text-success"
        }else if(res.transactionType === "AddPayment"){
          isTextColor = "text-warning"
        }
        return isTextColor
      }
    }
  }
</script>
